import React from 'react';
import styled from 'styled-components';
import VehicleStateImg from './vehicle-state-img';
import { VehicleModelProps } from './cargo-model';
import CabinImg from '../../assets/images/cargo-model/cabin.png';

class VehicleCabin extends React.Component<VehicleModelProps, any> {
  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler('cabin');
  };

  render() {
    const { className, vehicleState } = this.props;

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState.cabin}`}
        src={CabinImg}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleCabin = styled(VehicleCabin)`
  position: relative;
  width: 12.2em;
  top: -3.25em;
`;

export default StyledVehicleCabin;
